export default __webpack_public_path__ + "static/media/Solomon.6795f009.png";